import CustomButton from "common/components/Button/Button"
import CustomConfirmDialog from "common/components/ConfirmDialog"
import Dropzone from "common/components/Dropzone"
import FormikDropdown from "common/components/FormikFields/FormikDropdown"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import useToggle from "common/hooks/useToggle"
import {
  categoriaSelectedSelector,
  categoriasSelector,
  posiblesPadresOptionsSelector,
} from "features/Inventario/redux/selectors/categoriasSelectors"
import {
  deleteCategoria,
  updateCategoria,
} from "features/Inventario/redux/slices/categoriasSlice"
import { withFormik } from "formik"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useTranslation } from "react-i18next"
import * as Yup from "yup"
import ImagePreview from "../ImagePreview"

const CategoriaForm = ({
  values,
  setFieldValue,
  handleSubmit,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const [showModalDelete, toggleShowModalDelete] = useToggle(false)
  const dispatch = useDispatch()
  const { deletingCategoria, updatingCategoria } =
    useSelector(categoriasSelector)
  const categoriasOptions = useSelector(posiblesPadresOptionsSelector)

  const setImage = (image: $TSMigrationFixMe) => {
    setFieldValue("imageFile", image)
    setFieldValue("imagenBase64", null)
    setFieldValue("ficheroId", null)
  }

  const deleteImage = () => {
    setImage(null)
  }

  const onDrop = (files: $TSMigrationFixMe) => {
    setImage(files?.[0])
  }

  const handleDeleteCategoria = () => {
    dispatch(deleteCategoria(values.id))
  }

  return (
    <form
      className='mt-3 text-left p-fluid'
      onSubmit={handleSubmit}
    >
      <div className='p-field'>
        <label htmlFor='nombreCategoriaFormEdit'>
          {t("categorias.edit.labelName")}
        </label>

        <FormikInputText
          id='nombreCategoriaFormEdit'
          name='nombreCategoria'
        />
      </div>

      <div className='p-fluid'>
        <label>{t("categorias.edit.labelImg")}</label>

        <ImagePreview
          image={values.imageFile}
          imagenBase64={values.imagenBase64}
          imagenMediaType={values.imagenMediaType}
          setImage={setImage}
          deleteImage={deleteImage}
        />

        {!values.imageFile && !values.imagenBase64 && (
          <Dropzone
            maxFiles={1}
            acceptLabel='image/*'
            accept='image/*'
            onDrop={onDrop}
            hideAcceptedFilesMsg
            butonLabel={`${t("categorias.edit.labelAddImg")}`}
          />
        )}
      </div>

      <div className='mt-3 p-field'>
        <label htmlFor='categoriaPadreFormEdit'>
          {t("categorias.edit.labelFatherCategory")}
        </label>

        <FormikDropdown
          filter
          showClear
          options={categoriasOptions}
          placeholder={`${t("categorias.edit.placeholderFatherCategory")}`}
          id='categoriaPadreFormEdit'
          name='categoriaPadre'
        />
      </div>

      <div className='mt-3 d-flex justify-content-end'>
        <div>
          <CustomButton
            onClick={toggleShowModalDelete}
            loading={deletingCategoria}
            className='outlined'
            label={`${t("categorias.edit.labelDelete")}`}
          />
        </div>

        <div>
          <CustomButton
            loading={updatingCategoria}
            className='ml-2'
            type='submit'
            label={`${t("categorias.edit.labelSave")}`}
          />
        </div>
      </div>

      <CustomConfirmDialog
        visible={showModalDelete}
        onHide={toggleShowModalDelete}
        closable
        message={
          <span>
            {t("categorias.deleteQuestionMsgOne")}
            {' "'}
            {values?.nombreCategoria}
            &quot; {t("categorias.deleteQuestionMsgTwo")}
          </span>
        }
        header={
          <div className='d-flex justify-content-start'>
            <h6>{t("categorias.deleteButton")}</h6>
          </div>
        }
        acceptLabel={t("categorias.aceptButton")}
        rejectLabel={t("categorias.rejectButton")}
        accept={handleDeleteCategoria}
      />
    </form>
  )
}

const validationSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    nombreCategoria: Yup.string().nullable().required(t("errors.nameEmpty")),
  })

const EditCategoriaForm = ({ t }: $TSMigrationFixMe) => {
  const categoria = useSelector(categoriaSelectedSelector)
  const dispatch = useDispatch()

  const FormikForm = withFormik({
    mapPropsToValues: () => ({
      nombreCategoria: categoria?.nombre,
      imagenBase64: categoria?.imagenBase64,
      imagenMediaType: categoria?.imagenMediaType,
      imageFile: categoria?.imageFile,
      ficheroId: categoria?.ficheroId,
      categoriaPadre: categoria?.categoriaPadreId || "",
      id: categoria?.id,
    }),
    validationSchema: () => validationSchema(t),
    handleSubmit: (values) => {
      const putCategoria = {
        categoriaPadreId: values.categoriaPadre,
        imageFile: values.imageFile,
        imagenBase64: values.imagenBase64,
        ficheroId: values?.ficheroId,
        nombre: values.nombreCategoria,
        id: values.id,
      }
      // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
      dispatch(updateCategoria(putCategoria))
    },
  })(CategoriaForm)

  return <FormikForm />
}

export default EditCategoriaForm
